module.exports = __webpack_public_path__ + "media/images/home/icon-1-b9079823099f55ce861fa47ad03bd2de.png";